// 关联表单项
import React from 'react'
import { connect } from 'react-redux'
import { nullDate, TDate } from '../../public/utility'
import { hasChangedValues } from '../../public/utility/formValues'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, addListItemsFromListItems, resetListValues, isListValuesChanged, cloneListItem } from '../../public/utility'

class ProcessOperateFormItemDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetProcessOperateFormItem(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetProcessOperateFormItem = (id) => {
        Tyan.doPostEvent({
            event: 'GetProcessOperateFormItem',
            data: { id, ProcessOperateID: this.props.ProcessOperateID },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { ProcessOperateID, onRefresh, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        Tyan.doPostEvent({
            event: 'SaveProcessOperateFormItem',
            data: { id, ProcessOperateID, changedValues基本信息: values },
            onEnd: ({ id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onRefresh && onRefresh()
                    onClose && onClose()
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onRefresh, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteProcessOperateFormItem',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onRefresh && onRefresh()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerClose = () => {
        const { onRefresh, onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            onRefresh && onRefresh()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.表单项名称
    }

    fieldset基本信息 = () => {
        return [
            { _text: '操作名称', disabled: true, minWidth: '95%' },
            { _select: '表单项名称', required: true, minWidth: '95%' },
            { _radio: '操作方式', minWidth: '95%', },
            { _text: '条件', minWidth: '95%' },
            { _int: '排序', minWidth: '45%' }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="800" maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(ProcessOperateFormItemDiv)